export const STRATEGIES = {
    ALL: 'allStrategies',
    IN: 'inTheMoney',
    OUT: 'outTheMoney',
    NEAR: 'nearTheMoney'
};
